// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2caf08a8","839":"ab356791"}[chunkId] + ".chunk.js";
};